import React from 'react'
import ReactECharts from 'echarts-for-react'
import { EChartsOption } from 'echarts'
import { useTheme } from '../../../components/ThemeProvider'
import { getThemeSecondaryColor } from '../../../utils/themeConfig'

interface NonBankingApplicationRecordsChartProps {
  data: any
}

export default function NonBankingApplicationRecordsChart({ data }: NonBankingApplicationRecordsChartProps) {
  const theme = useTheme()

  const options: EChartsOption = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow',
      },
    },
    legend: {
      data: ['申请次数', '申请机构数'],
    },
    grid: {
      left: '3%',
      right: '4%',
      bottom: '3%',
      containLabel: true,
    },
    xAxis: {
      type: 'category',
      data: ['近7天', '近15天', '近1月', '近3月', '近6月', '近1年'],
      axisLabel: {
        fontSize: 10,
      },
    },
    yAxis: {
      type: 'value',
      min: 0,
      axisLabel: {
        formatter: '{value}',
      },
    },
    series: [
      {
        name: '申请次数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
        },
        itemStyle: {
          color: theme?.primaryColor,
        },
        data: [
          data?.nb_d7_apply_count ?? 0,
          data?.nb_d15_apply_count ?? 0,
          data?.nb_m1_apply_count ?? 0,
          data?.nb_m3_apply_count ?? 0,
          data?.nb_m6_apply_count ?? 0,
          data?.nb_m12_apply_count ?? 0,
        ],
      },
      {
        name: '申请机构数',
        type: 'bar',
        label: {
          show: true,
          color: '#ffffff',
        },
        itemStyle: {
          color: getThemeSecondaryColor(theme?.type),
        },
        data: [
          data?.nb_d7_apply_org_count ?? 0,
          data?.nb_d15_apply_org_count ?? 0,
          data?.nb_m1_apply_org_count ?? 0,
          data?.nb_m3_apply_org_count ?? 0,
          data?.nb_m6_apply_org_count ?? 0,
          data?.nb_m12_apply_org_count ?? 0,
        ],
      },
    ],
  }

  return <ReactECharts option={options} style={{ height: '350px' }} />
}
